module.exports = __webpack_public_path__ + "static/media/unavailable.a76165e9.svg";